import React, { Component } from 'react';
import { withGoogleMap, withScriptjs, GoogleMap, DirectionsRenderer } from 'react-google-maps';
import Utils from '../../library/utils';
import DIMENSIONS from '../../library/dimensions';

// const key = `${process.env.REACT_APP_API_URL === 'http://localhost:1337/' ? 'AIzaSyDADEQ0bhpw0KeNSKEliE1oO6o6aYSTrXc' : 'AIzaSyDIEJ7oDdmduVB97kqK6yGT2u5KvxbJQf4'}`;
const key = `AIzaSyDIEJ7oDdmduVB97kqK6yGT2u5KvxbJQf4`;


class LocalMap extends Component {
  state = {
    directions: null
  };

  componentDidMount() {
    Utils.waitForGlobal({key: 'google', sub: 'maps'}, () => {
      const google = window.google;
      const directionsService = new google.maps.DirectionsService();

      // Route:
      const origin = {lat: this.props.booking.original_route.pickupAddress.latitude, lng: this.props.booking.original_route.pickupAddress.longitude};
      const destination = {lat: this.props.booking.original_route.dropoffAddress.latitude, lng: this.props.booking.original_route.pickupAddress.longitude};

      // Added stops:
      const waypoints = [];
      const additionalStops = this.props.booking.original_route.additionalStops || [];
      for (const addedStop of additionalStops) {
        waypoints.push({
          location: {
            lat: addedStop.latitude,
            lng: addedStop.longitude
          },
          stopover: true
        })
      }

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          waypoints: waypoints,
          travelMode: google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.setState({
              directions: result
            });
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );

    });
  }

  render() {
    const GoogleMapExample = withGoogleMap(props => (
      <GoogleMap
        defaultCenter={props.center || {lat: 51.509865, lng: -0.118092}}
        defaultZoom={13}
      >
        <DirectionsRenderer
          directions={this.state.directions}
        />
      </GoogleMap>
    ));

    return (
      <div>
        <GoogleMapExample
          containerElement={<div style={{height: `500px`, width: `${DIMENSIONS.contentWidth}px`}}/>}
          mapElement={<div style={{height: `100%`}}/>}
        />
      </div>
    );
  }
}

const DirectionsMap = (props) => {
  const MapLoader = withScriptjs(LocalMap);

  return (
    <MapLoader
      {...props}
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${key}`}
      loadingElement={<div style={{height: `100%`}}/>}
    />
  );
};

export default DirectionsMap;


// WEBPACK FOOTER //
// ./src/components/booking-summary/directions-map.js